<button type="button" (click)="showConversionRules()" id="btn_AddNew" style="display:none">Add</button>
<button type="button" id="btnClone" (click)="ConfirmationCloneConversionRules()" style="display:none">Clone Confirm</button>
<button type="button" id="btnCloneRule" (click)="CloneConversionRules()" style="display:none">Clone Confirm</button>

<div id="ConversionRulesTable" class="divContainer" style="margin-top:10px;">
  <table #dataTable class="display" style="width:100%"></table>
</div>
<div class="modal" id="myModalRules" [style.display]="showRulesModal ? 'block' : 'none'">
  <div class="modal-dialog modal-xl custome-modal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{Title}}</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hideRules()">&times;</button>
      </div>
      <div class="modal-body">
        <div style="overflow:hidden !important;" id="popupbody">
          <ul class="nav nav-tabs nav-tabs-custom" id="ULTabul">
            <li class="nav-item"><a data-toggle="tab" href="#divRules1" class="nav-link active">General</a></li>
            <li class="nav-item" id="Rules2tab"><a data-toggle="tab" href="#divRules2" class="nav-link">Front Matter</a></li>
            <li class="nav-item" id="Rules3tab"><a data-toggle="tab" href="#divRules3" class="nav-link">Table & Figure</a></li>
            <li class="nav-item" id="Rules4tab"><a data-toggle="tab" href="#divRules4" class="nav-link">Title</a></li>
            <li class="nav-item" id="Rules5tab"><a data-toggle="tab" href="#divRules5" class="nav-link">Section</a></li>
            <li class="nav-item" id="Rules6tab"><a data-toggle="tab" href="#divRules6" class="nav-link">Others</a></li>
          </ul><br />
          <div class="tab-content" id="ConversionrulestabContent">
            <!--Rules 1 tab-->
            <div class="tab-pane active" id="divRules1" style="overflow-x:hidden; ">
              <div class="row">
                <div class="col-sm" id="JournalConversionruleName">
                  <div class="form-group">
                    <label for="txtConversionruleName">Conversion Rule Name<em>*</em></label>
                    <input type="text" class="form-control" id="txtConversionruleName" autocomplete="off" />
                  </div>
                </div>
                <div class="col-sm" id="JournalJournalList">
                  <div class="form-group">
                    <label for="ddlJournalList ">Journal</label>
                    <select id="ddlJournalList" class="form-control">
                      <option *ngFor="let item of journalList" value={{item.ID}}>
                        {{item.Acronym}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm" id="JournalPublisherType">
                  <div class="form-group">
                    <label for="ddlPublisherType ">Publisher Type</label>
                    <select id="ddlPublisherType" class="form-control">
                      <option *ngFor="let item of publisherType" value={{item.PublisherType}}>
                        {{item.PublisherType}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm" id="JournalProductType">
                  <div class="form-group">
                    <label for="ddlProductType ">Product Type</label>
                    <select id="ddlProductType" class="form-control">
                      <option *ngFor="let item of productType" value={{item.ProductType}}>
                        {{item.ProductType}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm" id="JournalReferenceStyle">
                  <div class="form-group">
                    <label for="ddlReferenceStyle ">Reference Style</label>
                    <select id="ddlReferenceStyle" class="form-control">
                      <option *ngFor="let item of referenceStyle" value={{item.ReferenceType}}>
                        {{item.ReferenceType}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-10">
                  <div class="form-group">
                    <label for="RuleTitle ">Title</label>
                    <textarea type="text" class="form-control" rows="2" id="RuleTitle"> </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RulesDegrees">Degrees</label>
                    <select class="form-control" id="RulesDegrees">
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleAffiliation">Affiliation</label>
                    <select class="form-control" id="RuleAffiliation">
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleAbstracthead">Abstract Head</label>
                    <select class="form-control" id="RuleAbstracthead">
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleDisclosureSection">Disclosure Section</label>
                    <select class="form-control" id="RuleDisclosureSection">
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleFundingSection">Funding Section</label>
                    <select class="form-control" id="RuleFundingSection">
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleCorresspondingAddress">Corresponding Address</label>
                    <select class="form-control" id="RuleCorresspondingAddress">
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>
              </div>


              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RulesLRH">LRH</label>
                    <textarea type="text" class="form-control" rows="5" id="RulesLRH"> </textarea>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleRRH ">RRH</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleRRH"> </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleAuthorGroup">Author Group</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleAuthorGroup"> </textarea>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleCorresspondingText">Corresponding Text</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleCorresspondingText"> </textarea>
                  </div>
                </div>
              </div>
            </div>
            <!--Rules 2 tab-->
            <div class="tab-pane" id="divRules2" style="overflow:hidden; ">
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleAffiliationElements">Affiliation Elements</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleAffiliationElements"> </textarea>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleAffiliationIndicator">Affiliation Indicator</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleAffiliationIndicator"> </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleKeywords">Keywords</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleKeywords"> </textarea>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleAbstractCount">Abstract Count</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleAbstractCount"> </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleQuotation ">Quotation</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleQuotation"> </textarea>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleCommaIEEG">Comma IEEG</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleCommaIEEG"> </textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleGraphicalAbstract">Graphical Abstract</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleGraphicalAbstract"> </textarea>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleCenturies">Centuries</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleCenturies"> </textarea>
                  </div>
                </div>
              </div>
            </div>
            <!--Rules 3 tab-->
            <div class="tab-pane" id="divRules3" style="overflow:hidden;">
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleTableCaption">Table Caption</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleTableCaption"> </textarea>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RulesTableCitation">Table Citation</label>
                    <textarea type="text" class="form-control" rows="5" id="RulesTableCitation"> </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleFigureCaption">Figure Caption</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleFigureCaption"> </textarea>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleFigureCitation">Figure Citation</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleFigureCitation"> </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleSection1">Section 1</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleSection1"> </textarea>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleSection2">Section 2</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleSection2"> </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleSection3">Section 3</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleSection3"> </textarea>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleSection4">Section 4</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleSection4"> </textarea>
                  </div>
                </div>
              </div>



            </div>
            <!--Rules 4 tab-->
            <div class="tab-pane" id="divRules4" style="overflow:hidden; ">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleBibArticleTitle">Bib Article Title</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleBibArticleTitle"> </textarea>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleJournalTitle">Journal Title</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleJournalTitle"> </textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleChapterTitle">Chapter Title</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleChapterTitle"> </textarea>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleBookTitle">Book Title</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleBookTitle"> </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleReportTitle">Report Title</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleReportTitle"> </textarea>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleConferenceTitle">Conference Title</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleConferenceTitle"> </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RulePaperTitle">Paper Title</label>
                    <textarea type="text" class="form-control" rows="5" id="RulePaperTitle"> </textarea>
                  </div>
                </div>
                
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleThesisTitle">Thesis Title</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleThesisTitle"> </textarea>
                  </div>
                </div>
              </div>



            </div>
            <!--Rules 5 tab-->
            <div class="tab-pane" id="divRules5" style="overflow:hidden; ">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleNoteStyle">Note Style</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleNoteStyle"> </textarea>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleDataAvailabilitySection">Data Availability Section</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleDataAvailabilitySection"> </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleEthicalApprovalSection">Ethical Approval Section</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleEthicalApprovalSection"> </textarea>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleInformedConsentSection">Informed Consent Section</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleInformedConsentSection"> </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleTrialRegistrationSection">Trial Registration Section</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleTrialRegistrationSection"> </textarea>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleSupplementarySection">Supplementary Section</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleSupplementarySection"> </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleAuthorContributionSection">Author Contribution Section</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleAuthorContributionSection"> </textarea>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleBiographySection">Biography Section</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleBiographySection"> </textarea>
                  </div>
                </div>

              </div>

            </div>

            <div class="tab-pane" id="divRules6" style="overflow:hidden; ">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleConferenceName">Conference Name</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleConferenceName"> </textarea>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RulepageRange">Page Range</label>
                    <textarea type="text" class="form-control" rows="5" id="RulepageRange"> </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleHistoryFormat">History Format</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleHistoryFormat"> </textarea>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RulesThousandSeparator">Thousand Separator</label>
                    <textarea type="text" class="form-control" rows="5" id="RulesThousandSeparator"> </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RuleYearApos">Year Apos</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleYearApos"> </textarea>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RulesDashes">Dashes</label>
                    <textarea type="text" class="form-control" rows="5" id="RulesDashes"> </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <label for="RulesParentheticalDash">Parenthetical Dash</label>
                    <textarea type="text" class="form-control" rows="5" id="RulesParentheticalDash"> </textarea>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="RuleBackmatterOrder">Backmatter Order</label>
                    <textarea type="text" class="form-control" rows="5" id="RuleBackmatterOrder"> </textarea>
                  </div>
                </div>
              </div>

            </div>


          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideRules()">Close</button>
        <button type="submit" (click)="addUpdateConversionRules()" class="btn btn-outline-success waves-effect waves-light">{{RulesModalButton}}</button>
      </div>
    </div>
  </div>
</div>
